import React, { useState } from 'react';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

export default function Generate() {
  const [loading, setLoading] = useState(false);
  const [nlSignupStatus, setNlSignupStatus] = useState('');
  const [userPrompt, setUserPrompt] = useState('');
  const [completion, setCompletion] = useState('');
  const [id, setId] = useState('');

  // Handle newsletter signup form submission
  const handleSubmitSignup = async (event) => {
    event.preventDefault();
    const email = new FormData(event.target).get('email');
    if (!email || !email.trim()) {
      alert('Please enter a valid email address.');
      return;
    }
  
    try {
      const response = await fetch(`${API_URL}/api/event_newsletter_su`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      const result = await response.json();
      setNlSignupStatus(result.message);
    } catch (error) {
      console.error('Error submitting the signup form:', error);
      setNlSignupStatus(error.message);
    }
  };

  // Handle user input change
  const handleInputChange = (event) => {
    setUserPrompt(event.target.value);
  };

  // Handle form submission to generate a story
  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!userPrompt.trim() || loading) return;
    try {
      setLoading(true);
      const response = await fetch(`${API_URL}/api/generate_story`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ user_prompt: userPrompt }),
      });
      if (response.ok) {
        const result = await response.json();
        setCompletion(result.completion);
        setId(result.id);
      } else {
        console.error(`Failed to fetch: ${response.status} - ${await response.text()}`);
      }
    } catch (error) {
      console.error('Error submitting form:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="row justify-content-center" style={{ backgroundColor:"#d5f5e3" }} >
      <div className="col-md-6 col-sm-12">
        <div className="text-center">
          { loading ? (
              // Display placeholder while loading
              <img src="/timer.gif" alt="Loading..." className="img-fluid mb-2 mt-2" />
            ) : 
            <img id="coloringpage" className="img-fluid message bot print" src='https://butterpuppies.s3.us-west-1.amazonaws.com/static/banner.png' />
          }
        </div>
      </div>
      </div>
      <div className="row justify-content-center" style={{ backgroundColor:"#d5f5e3" }} >
            <h4 className="mb-3 mt-3 text-center ">{ completion ? userPrompt : "Write me a short story!"  }</h4>
      </div>
      <div className="row justify-content-center" style={{ backgroundColor: "#d5f5e3" }}>
        <div className="col-md-6 col-sm-12 text-center rounded" >
        <div style={{ whiteSpace: 'pre-line' }}>
            {completion}
            <br/>            
        </div>
        {completion ? <div id="shareid" class="border mb-2 rounded text-center bg-light" disabled>{`www.babyboo.dev/story/${id}`}</div> : "" }
        
          <form onSubmit={handleSubmit}>
            <div className="row">
              <input
                type="text"
                className="form-control mb-2 text-center"
                placeholder="Two friends on a picnic"
                onChange={handleInputChange}
                value={userPrompt}
              />
              <input
                className="btn btn-dark"
                type="submit"
                value={loading ? "Loading..." : completion ? "Create another!" : "Create!"}
                disabled={loading}
              />
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
